import { type Html, html, View } from 'rune-ts';
import klass from './HeaderSection.module.scss';
import { MarppleShopLogo_commerce } from '../../../../../shared/components/atoms/Icon/identity_icons';
import NewHeadroom from 'headroom.js';

export class HeaderSection extends View {
  constructor() {
    super({});
  }

  override template(): Html {
    return html`
      <section class="${klass.landing_header}">
        <div class="${klass.logo}">
          <a href="/" target="_blank">${MarppleShopLogo_commerce({ klass: klass.mp_logo })} </a>
        </div>
      </section>
    `;
  }

  protected override onRender() {
    const headroom_el$ = this.element();
    const headroom = new NewHeadroom(headroom_el$, {});
    headroom.init();
  }
}
